
<template>
  <!-- 面包屑 -->
  <div class="crumbs">
    <el-breadcrumb separator="/">
      <template v-for="(item, index) in crumb.list" :index="index">
        <el-breadcrumb-item :key="item">{{ item }}</el-breadcrumb-item>
      </template>
    </el-breadcrumb>
    <h1>
      <span>{{ crumb.titBig || crumb.list[crumb.list.length - 1] }}</span>
      <slot class="fr"></slot>
    </h1>
  </div>
</template>

<script>
export default {
  props: {
    crumb: "",
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.crumbs {
  height: 70px;
  .el-breadcrumb {
    font-size: 15px;
  }
  h1 {
    font-size: 20px;
    margin-top: 15px;
    border-width: 500;
  }
}
</style>
